import { render, staticRenderFns } from "./JoiningApplicationEducationalTabs.vue?vue&type=template&id=684d7c5d&"
import script from "./JoiningApplicationEducationalTabs.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationEducationalTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports